import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33ac9632"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "versions" }
const _hoisted_2 = { class: "content-wrapper with-nav" }
const _hoisted_3 = { class: "live-wrapper" }
const _hoisted_4 = { class: "details" }
const _hoisted_5 = { class: "stats" }
const _hoisted_6 = { class: "metric" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Intentionen", -1))
const _hoisted_8 = { class: "metric" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Abläufe", -1))
const _hoisted_10 = { class: "metric" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Blöcke", -1))
const _hoisted_12 = { class: "progress-wrapper" }
const _hoisted_13 = { class: "details" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "models" }
const _hoisted_16 = {
  key: 1,
  class: "material-icons-round published"
}
const _hoisted_17 = {
  key: 2,
  class: "material-icons-round failed"
}
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Version veröffentlichen")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Version veröffentlichen")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_card = _resolveComponent("md-card")!
  const _component_md_progress_indicator_circular = _resolveComponent("md-progress-indicator-circular")!
  const _component_md_table_column = _resolveComponent("md-table-column")!
  const _component_md_table = _resolveComponent("md-table")!
  const _component_md_button = _resolveComponent("md-button")!
  const _component_empty_hint = _resolveComponent("empty-hint")!
  const _component_version_publish_overlay = _resolveComponent("version-publish-overlay")!
  const _component_md_overlay = _resolveComponent("md-overlay")!
  const _component_md_fab_extended = _resolveComponent("md-fab-extended")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.lastVersion && _ctx.isLastVersionPublished)
        ? (_openBlock(), _createBlock(_component_md_card, {
            key: 0,
            variant: "filled",
            class: "live-version"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("h2", null, "Version " + _toDisplayString(_ctx.lastVersion.id) + " ist live", 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.getFormattedDate(_ctx.lastVersion.created.toDate())) + " um " + _toDisplayString(_ctx.getFormattedTime(_ctx.lastVersion.created.toDate())) + " Uhr", 1)
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("h1", null, _toDisplayString(_ctx.lastVersion.stats.intents), 1),
                    _hoisted_7
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("h1", null, _toDisplayString(_ctx.lastVersion.stats.flows), 1),
                    _hoisted_9
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("h1", null, _toDisplayString(_ctx.lastVersion.stats.blocks), 1),
                    _hoisted_11
                  ])
                ])
              ])
            ]),
            _: 1
          }))
        : (_ctx.lastVersion && _ctx.models)
          ? (_openBlock(), _createBlock(_component_md_card, {
              key: 1,
              variant: "outlined",
              class: "progress-version"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("h2", null, "Version " + _toDisplayString(_ctx.lastVersion.id) + " wird bereitgestellt...", 1),
                    (_ctx.lastVersion.updated)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.getFormattedDate(_ctx.lastVersion.updated.toDate())) + " um " + _toDisplayString(_ctx.getFormattedTime(_ctx.lastVersion.updated.toDate())) + " Uhr", 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lastVersion.models, (state, model) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "model",
                        key: model
                      }, [
                        (state == 'processing')
                          ? (_openBlock(), _createBlock(_component_md_progress_indicator_circular, { key: 0 }))
                          : (state == 'published')
                            ? (_openBlock(), _createElementBlock("i", _hoisted_16, "check_circle"))
                            : (_openBlock(), _createElementBlock("i", _hoisted_17, "error")),
                        _createElementVNode("span", null, _toDisplayString(_ctx.getModelName(model)), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
      ((_ctx.rows && _ctx.rows.length > 0) || _ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_md_table, {
            key: 2,
            rows: _ctx.rows
          }, {
            default: _withCtx(() => [
              _createVNode(_component_md_table_column, {
                title: "Version",
                display: "id"
              }),
              _createVNode(_component_md_table_column, {
                title: "",
                display: "state",
                type: "badge"
              }),
              _createVNode(_component_md_table_column, {
                title: "Name",
                display: "name"
              }),
              _createVNode(_component_md_table_column, {
                title: "Veröffentlicht",
                display: "created"
              }),
              _createVNode(_component_md_table_column, {
                title: "",
                display: "publish",
                type: "button"
              }),
              _createVNode(_component_md_table_column, {
                title: "",
                display: "delete",
                type: "button"
              })
            ]),
            _: 1
          }, 8, ["rows"]))
        : (_openBlock(), _createBlock(_component_empty_hint, {
            key: 3,
            title: "Keine Version bereitgestellt",
            description: "Es wurde noch keine Version deines Chatbots bereitgestellt. Erstelle eine neue Version, damit Nutzer deinen Chatbot erreichen können."
          }, {
            default: _withCtx(() => [
              _createVNode(_component_md_button, { variant: "filled" }, {
                default: _withCtx(() => [
                  _hoisted_18
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
    ]),
    _createVNode(_component_md_overlay, {
      title: "Neue Version bereitstellen",
      visible: _ctx.publishVersionVisible,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.publishVersionVisible) = $event)),
      loading: _ctx.publishVersionLoading,
      image: _ctx.PublishVersionImage
    }, {
      default: _withCtx(() => [
        _createVNode(_component_version_publish_overlay, {
          onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.publishVersionVisible = false)),
          onLoading: _cache[1] || (_cache[1] = ($event: any) => (_ctx.publishVersionLoading = $event)),
          onComplete: _ctx.publishingStarted
        }, null, 8, ["onComplete"])
      ]),
      _: 1
    }, 8, ["visible", "loading", "image"]),
    _createVNode(_component_md_fab_extended, {
      icon: "publish",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.publishVersionVisible = true))
    }, {
      default: _withCtx(() => [
        _hoisted_19
      ]),
      _: 1
    })
  ]))
}